import { memberCalls2Url } from '@helpers'
import axios from 'axios'

const findAddress = async ({ keyword, countryCode2Alpha, signal }: { keyword: string; countryCode2Alpha: string; signal: AbortSignal }) => {
    const path = `/unishop-fn-misc/city/search?country_code=${countryCode2Alpha}&keyword=${keyword}`
    const response = await fetch(memberCalls2Url({ path: path }), { signal })
    return response.json()
}

export type TCreateUuidData = {
    fullname_jp: string
    token: string
    ba_status: string
    email: string
    login_id: string
    login_name: string
    login_name_native: string
    period: string
    phone: string
    agent: string
    medium: string
    platform: string
    send_confirmation: boolean
    shipment_options: string
    shipToAddress: string | object
    items: string
    district: string
    prefecture: string
    town: string
    house_number: string
    zip: string
    selectAddressHistory?: string
}

const createUuid = async ({ data, isSaveAddressHistory }: { data: TCreateUuidData; isSaveAddressHistory?: boolean }) => {
    const path = `/hot/formatV2/JPN/spotlight/address${isSaveAddressHistory ? '?isSaveAddressHistory=1' : ''}`
    const response = await axios.post(memberCalls2Url({ path: path }), { ...data })
    return response
}

const getOrderDetail = async ({ uuid }: { uuid: string }) => {
    const path = `/hot/format/JPN/spotlight/detail-v2/${uuid}`
    const response = await axios.get(memberCalls2Url({ path: path }))
    return response
}

const updateOrderDetail = async ({ uuid, email, phone, countryCode3Alpha }: { uuid: string; email: string; phone: string; countryCode3Alpha: string }) => {
    const path = `/hot/formatV2/${countryCode3Alpha}/spotlight/address`
    const response = await axios.put(memberCalls2Url({ path: path }), {
        email,
        phone,
        uuid
    })
    return response
}

const getAddressHistory = async ({ baId, ushopCountryCode, token }: { baId: string; ushopCountryCode: string; token: string }) => {
    const path = `/etlV2/addressHistory?baId=${baId}&ushopCountryCode=${ushopCountryCode}`
    const headers = {
        'Authorization-hydra': `Bearer ${token}`
    }
    const response = await axios.get(memberCalls2Url({ path: path }), { headers })
    return response
}

const getAddressHistoryByHydra = async ({ token }: { token: string }) => {
    const url = 'https://hydra.unicity.net/v5a/customers/me/shiptooptions'
    return axios.get(url, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    })
}

const deleteAddressHistory = async ({ addressHref, baHref, token }: { addressHref: string; baHref: string; token: string }) => {
    const url = `https://hydra.unicity.net/v5a/customers/${baHref}/shiptooptions/${addressHref}`
    const response = await axios.delete(url, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    })
    return response
}

const validatePhoneOrEmail = async ({ phone, email }: { phone: string; email: string }) => {
    const path = `/hot/formatV2/JPN/spotlight/address?isValidateOnlyPhoneAndEmail=1`
    const response = await axios.post(memberCalls2Url({ path: path }), { phone, email })
    return response
}

export const addressApis = {
    findAddress,
    createUuid,
    getOrderDetail,
    updateOrderDetail,
    getAddressHistory,
    getAddressHistoryByHydra,
    deleteAddressHistory,
    validatePhoneOrEmail
}
